import { useState } from "react";
import { Dropdown } from "./dropdown";
import styles from "./styles.module.scss";
import {
  AssignedToIcon,
  CalenderIcon,
  CalenderIconBlack,
  CreatedByIcon,
  StatusIcon,
} from "icons";
import { DatePicker, Divider } from "antd";
import { ConditionalRenderer } from "components";
import { CalendarFilled } from "@ant-design/icons";
import { useGetCategoriesList } from "hooks/use-get-categories";
import { getFormattedDate } from "utils/helpers";
import dayjs from "dayjs";
import { useLanguageTranslator } from "hooks/use-language-translator";

export const ReminderFilters = ({
  employees,
  getReminders,
  filtersData,
  setFiltersData,
  refetchReminderHistory,
  variant,
  onClose,
  getLengthOfActiveFilters,
}) => {
  const { translator } = useLanguageTranslator();
  const reminderTrans = translator("caseDetail.reminder");
  const { categories } = useGetCategoriesList();

  const statusOptions = [
    {
      label: translator("pending"),
      value: "PENDING",
    },
    {
      label: translator("done"),
      value: "DONE",
    },
  ];
  let dropdowns = [
    {
      name: "dueDate",
      label: reminderTrans.dueDate,
      icon: CalenderIconBlack,
    },
    {
      name: "category",
      options: categories,
      label: reminderTrans.category,
      icon: CreatedByIcon,
    },
    {
      name: "createdBy",
      options: employees,
      label: reminderTrans.createdBy,
      icon: CreatedByIcon,
    },
    {
      name: "assignedTo",
      options: employees,
      label: reminderTrans.assignedTo,
      icon: AssignedToIcon,
    },
    {
      name: "status",
      options: statusOptions,
      label: reminderTrans.status,
      icon: StatusIcon,
    },
  ];
  dropdowns = variant === "pending" ? dropdowns?.slice(0, 4) : dropdowns;

  // const [filtersData, setFiltersData] = useState({
  //   dueDate: null,
  //   createdBy: null,
  //   assignedTo: null,
  //   status: null,
  //   category: null,
  // });

  const handleSelectOption = (name) => (value, option) => {
    setFiltersData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  async function handleApplyFilters() {
    getLengthOfActiveFilters(filtersData);
    refetchReminderHistory();
    onClose();
  }
  function handleChangeDate(date, dateString) {
    setFiltersData((prev) => ({
      ...prev,
      dueDate: dateString,
    }));

    // handleUpdateCase(item.key, dateString);
    // refetchFieldHistory();
  }
  function getFormateDate(date) {
    if (date) {
      if (date?.includes(".")) {
        const format = date?.replace(/\./g, "-");
        return dayjs(format, ["DD-MM-YYYY", "DD-MM-YY"], true);
      } else if (date?.includes("-")) {
        return dayjs(filtersData["dueDate"]);
      }
    }
  }
  return (
    <div>
      <div className={styles.filters}>
        {dropdowns.map((item) => (
          <div className={styles.singleFilter}>
            <div className={styles.label}>
              <item.icon />
              {item.label}
            </div>
            <div className={styles.dropdownWrapper}>
              <ConditionalRenderer condition={item.name === "dueDate"}>
                <DatePicker
                  style={{ height: "100%", width: "100%" }}
                  placeholder={"DD.MM.YYYY"}
                  allowClear
                  format="DD.MM.YYYY"
                  value={
                    filtersData["dueDate"] &&
                    getFormateDate(filtersData["dueDate"])
                  }
                  onChange={handleChangeDate}
                  name="dueDate"
                  inputReadOnly
                />
              </ConditionalRenderer>
              <ConditionalRenderer condition={item.name !== "dueDate"}>
                <Dropdown
                  options={item.options}
                  value={filtersData[item.name]}
                  handleSelectOption={handleSelectOption(item.name)}
                />
              </ConditionalRenderer>
            </div>
          </div>
        ))}
      </div>
      <Divider />
      <div className={styles.buttons}>
        <div className={styles.clearAll} onClick={() => setFiltersData({})}>
          {translator("resetAll")}
        </div>
        <div className={styles.verticalLine}></div>
        <button className={styles.apply} onClick={handleApplyFilters}>
          {translator("applyFilters")}
        </button>
      </div>
    </div>
  );
};
